import { jsx as a } from "react/jsx-runtime";
import { GradientButton as n } from "../gradient-button/index.js";
import r from "./styles.module.less.js";
const c = (t) => {
  const { getTranslation: e, isScrolledHeader: o } = t;
  return /* @__PURE__ */ a(
    n,
    {
      label: e("pages.chat-now"),
      path: "/chat?newCase=true",
      isScrolledHeader: o
    }
  );
}, i = (t) => {
  const { getTranslation: e } = t;
  return /* @__PURE__ */ a(
    n,
    {
      label: e("pages.chat"),
      path: "/chat?newCase=true",
      className: r.mobileMenuGradientButton
    }
  );
};
export {
  c as MenuChatButtonDesktop,
  i as MenuChatButtonMobile
};
